import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
  name: "OriginsChartComponent",
  datasets: [],
  labels: "months",
  loading: true,
  style:"height: 150px",
  options: ChartOptions.getOriginChartOptions()
}